(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bacter-calculators-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  // Abrir popup
  var openBtn = e.target.closest('[data-open-modal]');
  if (openBtn) {
    var targetId = openBtn.getAttribute('data-open-modal');
    var modal = document.getElementById(targetId);
    if (modal) {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  }

  // Cerrar con botón "X"
  if (e.target.matches('[data-close-modal]')) {
    var m1 = e.target.closest('.bacter-modal');
    if (m1) {
      m1.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  // Cerrar al hacer clic en el fondo oscuro
  if (e.target.classList.contains('bacter-modal')) {
    e.target.style.display = 'none';
    document.body.style.overflow = '';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
